export default __webpack_public_path__ + "static/media/spf_4978_49555776376_o.7b0062e0.jpg";